import React from 'react';
import { defineMessages, FormattedMessage } from '@kyruus/intl';
import { Link } from 'react-router-dom';
import _findIndex from 'lodash/findIndex';

import {
  getClearFiltersSearch,
  getLogClearSearchFilters
} from '../utils/search-common';
import SortMenu from '../shared/sort-menu';
import { SearchSummary } from '../shared/SearchSummary';
import {
  MobileViewResultWrapper,
  MobileViewResultContainer,
  MobileViewResultBtn,
  StyledButtonTopPanel,
  StyledFacetsFixedTop,
  StyledCloseButton
} from './styles';

const messages = defineMessages({
  found: {
    id: 'resultsheader.searchdescription.found',
    description: 'The number of providers returned for the search',
    defaultMessage: `{providerCount} {providerCount, plural,
      one {provider}
      other {providers}
    } found`
  },
  clearfilters: {
    id: 'resultsheader.clearfilters',
    description: 'Button text to clear all previously selected filters',
    defaultMessage: 'Clear All Filters'
  },
  viewresults: {
    id: 'resultsheader.viewresults',
    description: 'Button text to view filter results',
    defaultMessage: 'View Results'
  },
  close: {
    id: 'resultsheader.close',
    description: 'Button text to close filter results',
    defaultMessage: 'Close'
  },
  sortandfilter: {
    id: 'resultsheader.searchdescription.sortandfilter',
    description: 'Button text to sort results and apply filters',
    defaultMessage: 'Sort and Filter'
  }
});

const FACETS_OPEN = 'facets-open';

class StopScroll extends React.Component {
  componentDidMount() {
    const container = this.props.container || window.document.body;
    const classNames = container.className.split[' '] || [];
    classNames.push(FACETS_OPEN);
    container.className = classNames.join(' ');
  }

  componentWillUnmount() {
    const container = this.props.container || window.document.body;
    const classNames = container.className.split[' '] || [];
    const openIndex = _findIndex(classNames, FACETS_OPEN);
    container.className = classNames.splice(openIndex, 1);
  }

  render() {
    return null;
  }
}

function MobileFiltersHeader({
  searchSummary,
  getUpdatedSearch,
  log,
  toggleMobileFacets
}) {
  let clearLink = null;
  if (
    searchSummary.has_filters ||
    searchSummary.filter?.length ||
    searchSummary.location
  ) {
    const logClearFilters = getLogClearSearchFilters(log);
    const clearFiltersSearch = getClearFiltersSearch(getUpdatedSearch);
    clearLink = (
      <Link
        to={clearFiltersSearch}
        id="clear-filters-mobile"
        className="clear-filters"
        onClick={logClearFilters}
      >
        <FormattedMessage {...messages.clearfilters} />
      </Link>
    );
  }

  return (
    <React.Fragment>
      <MobileViewResultWrapper>
        <MobileViewResultContainer>
          <MobileViewResultBtn
            id="hide-filters-mobile"
            className="hide-filters button btn-m"
            onClick={toggleMobileFacets}
          >
            <FormattedMessage {...messages.viewresults} />
          </MobileViewResultBtn>
        </MobileViewResultContainer>
      </MobileViewResultWrapper>
      <StyledButtonTopPanel>
        <StopScroll />
        <StyledFacetsFixedTop data-testid="facets-back-fixed-top">
          {clearLink}
          <StyledCloseButton
            mode="flat"
            onClick={(e) => {
              e.preventDefault();
              toggleMobileFacets();
            }}
          >
            <FormattedMessage {...messages.close} />
          </StyledCloseButton>
        </StyledFacetsFixedTop>
      </StyledButtonTopPanel>
    </React.Fragment>
  );
}

function MobileResultsHeader({ config, totalProviders, toggleMobileFacets }) {
  const { updated_filter_bar } = config.darkship_feature_flags;

  return (
    <div className="consumer-facets-mobile col-md-1 mb-l">
      <h3 className="d-inline-block">
        <span className="result-item" id="provider-count-mobile">
          <FormattedMessage
            {...messages.found}
            values={{
              providerCount: totalProviders
            }}
          />
        </span>
      </h3>
      {updated_filter_bar || (
        <button
          onClick={toggleMobileFacets}
          id="show-filters-mobile"
          className="show-filters f-right hidden-print button btn-simple"
        >
          <FormattedMessage {...messages.sortandfilter} />
          &nbsp;»
        </button>
      )}
    </div>
  );
}

function ResultsHeader({
  totalProviders,
  searchSummary,
  sortOptions,
  getUpdatedSearch,
  log,
  isLoadingOverlayShown
}) {
  return (
    <div className="row hidden-xs hidden-sm mb-s">
      <div className="col-md-6">
        <SearchSummary
          totalProviders={totalProviders}
          searchSummary={searchSummary}
          getUpdatedSearch={getUpdatedSearch}
          log={log}
          isLoadingOverlayShown={isLoadingOverlayShown}
        />
      </div>
      <div className="col-md-6">
        <div className="f-right mb-s hidden-print" data-view="sort">
          <SortMenu
            searchSummary={searchSummary}
            sortOptions={sortOptions}
            getUpdatedSearch={getUpdatedSearch}
          />
        </div>
      </div>
    </div>
  );
}

export { MobileFiltersHeader, MobileResultsHeader };
export default ResultsHeader;
